import { Checkbox } from "../beui/Checkbox";
import { useEffect, useState } from "react";
import { api, type AgreementDocument as Document } from "../../lib/api";
import { Modal } from "../beui/Modal";
import { AgreementDocument } from "../AgreementDocument";
import "../../pages/LegalHub.css";

export function BuyerPurchaseOffer({ quoteId, canAccept, onClose, onAccept }: {
  quoteId: string; canAccept: boolean; onClose: () => void; onAccept: (documentId: string) => Promise<void>;
}) {
  const [document, setDocument] = useState<Document | null>(null), [error, setError] = useState<string | null>(null);
  const [reviewed, setReviewed] = useState(false), [busy, setBusy] = useState(false), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true; setDocument(null); setError(null); setReviewed(false);
    api.getItemArrangementQuote(quoteId).then(result => {
      if (!result?.quote.agreementDocument) throw new Error("The recorded seller offer is unavailable. Retry loading before accepting.");
      if (current) setDocument(result.quote.agreementDocument);
    }).catch(failure => { if (current) setError(failure instanceof Error ? failure.message : "Could not load this offer."); });
    return () => { current = false; };
  }, [quoteId, attempt]);
  async function accept() {
    if (!document || !reviewed || busy) return;
    setBusy(true); setError(null);
    try { await onAccept(document.id); onClose(); }
    catch (failure) { setError(failure instanceof Error ? failure.message : "Could not confirm acceptance. Retry this same proposal."); }
    finally { setBusy(false); }
  }
  return <Modal className="message-form-editor" label="Seller purchase proposal" onClose={() => { if (!busy) onClose(); }}>
    <header className="legal-reader-head"><h2 className="text-lg font-bold text-navy">Seller purchase proposal</h2></header>
    <div className="legal-reader-body space-y-4">
      {document ? <AgreementDocument document={document} /> : !error && <p role="status">Loading seller offer…</p>}
      {canAccept && document && <Checkbox label="I accept this purchase proposal" checked={reviewed} onCheckedChange={setReviewed} className="items-start" />}
      {error && <p role="alert" className="text-sm text-brand-red">{error}</p>}
      {error && !document && <button type="button" className="btn-outline" onClick={() => setAttempt(current => current + 1)}>Retry loading</button>}
    </div>
    <footer className="legal-reader-foot flex justify-end gap-2"><button type="button" disabled={busy} className="btn-outline" onClick={onClose}>Close</button>{canAccept && <button type="button" disabled={busy || !document || !reviewed} className="btn-red" onClick={() => void accept()}>Accept proposal</button>}</footer>
  </Modal>;
}
